<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="pt-0">
        <div style="white-space: pre-wrap;">{{ trans('description') }}</div>
      </v-col>
      <v-col cols="12" v-if="loading">
        <v-progress-linear
          v-if="loading"
          height="2px"
          :indeterminate="true"
          :value="0"
        />
      </v-col>
      <v-col cols="12" v-if="$nativeApp.isIOS()">
        <info-block>{{trans('native-not-available-yet')}}</info-block>
      </v-col>
    </v-row>
    <v-row v-if="coinProducts && !$nativeApp.isIOS()">
      <v-col cols="12" v-if="!userHasPremium() && envGetUserKey('coins.premiumSavings') > 0 && isPremiumFeatureEnabled()">
        <info-block>{{trans('coin-product-savings-premium', {savings: envGetUserKey('coins.premiumSavings')})}}</info-block>
      </v-col>
      <v-col cols="12" v-if="userHasPremium() && envGetUserKey('coins.premiumSavings') > 0 && isPremiumFeatureEnabled()">
        <info-block>{{trans('coin-product-savings-with-premium', {savings: envGetUserKey('coins.premiumSavings')})}}</info-block>
      </v-col>
      <v-col cols="12" v-for="product in coinProducts" :key="product.sku">
        <v-btn
          class="secondary"
          @click="openPurchaseProduct(product)"
          style="text-transform: inherit"
        >
          <v-icon left>mdi-circle-multiple-outline</v-icon>
          {{ product.name }} {{ purchaseValueToString(product.total) }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { EVENT_REFRESH_DATA } from '@/plugins/eventbus'
import purchaseProduct from '@/mixins/purchaseProduct'
import InfoBlock from './InfoBlock.vue'
import profileMixin from '@/mixins/profileMixin'
import envMixin from '@/mixins/envMixin'

export default {
  name: "CoinProducts",
  mixins: [purchaseProduct, profileMixin, envMixin],
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  components: {InfoBlock},

  data: () => ({
    loading: false,
    coinProducts: undefined,
  }),
  mounted() {
    this.refresh();
    this.$eventBus.$on(EVENT_REFRESH_DATA, this.refresh);
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_REFRESH_DATA, this.refresh);
  },
  methods: {
    refresh: function () {
      this.loading = true;
      this.$api
        .getCoinProducts()
        .then((res) => {
          this.loading = false;
          this.coinProducts = res.data.list;
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
    },
    openPurchaseProduct(product) {
      this.purchaseProduct(product.sku); // mixin
    },
    trans(key, options) {
      const tenantKey = 'coins.' + this.$tenant.tenant + '.' + key
      // try to resolve text by tenant
      if (this.$t(tenantKey) != tenantKey) {
        return this.$t(tenantKey, options)
      }

      // take default translation
      return this.$t('coins.' + key, options)
    }
  },
};
</script>
